import React, { useState } from "react";
import { T } from "../theme/tokens.js";
import Roster from "../components/Roster.jsx";
import WeeklyHours from "../components/WeeklyHours.jsx";

/* The People hub. Two ways to look at the same workforce: the roster, which is
   who is on what across every program, and utilization, which is how full they
   are week by week. Both are firm-wide and admin-maintained. */
const TABS = [
  { key: "roster", label: "Roster" },
  { key: "utilization", label: "Utilization" },
];

export default function People({ contracts = [], isAdmin }) {
  const [tab, setTab] = useState("roster");
  return (
    <div style={{ display: "grid", gap: 16 }}>
      <div style={{ display: "flex", gap: 2, borderBottom: `1px solid ${T.line}` }}>
        {TABS.map((t) => {
          const on = tab === t.key;
          return (
            <button key={t.key} onClick={() => setTab(t.key)} style={{
              background: "none", border: "none", cursor: "pointer", padding: "9px 16px",
              fontSize: 13.5, fontWeight: on ? 700 : 500, color: on ? T.navy : T.soft,
              borderBottom: on ? `2px solid ${T.gold}` : "2px solid transparent",
              marginBottom: -1,
            }}>{t.label}</button>
          );
        })}
      </div>
      {tab === "roster"
        ? <Roster contracts={contracts} isAdmin={isAdmin} />
        : <WeeklyHours contracts={contracts} isAdmin={isAdmin} />}
    </div>
  );
}
